import { render } from "./RequestUser.view.vue?vue&type=template&id=1e5396bf"
import script from "./RequestUser.view.vue?vue&type=script&lang=js"
export * from "./RequestUser.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__